// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// Partials
import { PartialsModule } from '../partials/partials.module';
import { ModalAlertComponent } from '../partials/content/crud/modal-alert/modal-alert.component';
import {
    DebitsCreditsProcessDialogComponent
} from '../partials/content/crud/debits-credits-process-dialog/debits-credits-process-dialog.component';
import { PdfViewerDialogComponent } from '../partials/content/crud/pdf-viewer-dialog/pdf-viewer-dialog.component';
import { ConfirmDialogComponent } from '../partials/content/crud/confirm-dialog/confirm-dialog.component';
import { ResendInvoiceDialogComponent } from '../partials/content/crud/resend-invoice-dialog/resend-invoice-dialog.component';
import { ConfirmComponent } from '../partials/content/general/confirm-dialog/confirm-dialog.component';
import { CustomerStatementEmailComponent } from '../partials/content/crud/customer-statement-email/customer-statement-email.component';

// Pages
import { CoreModule } from '../../core/core.module';
import { MyPageComponent } from './my-page/my-page.component';

// Translate
import { TranslateModule } from '@ngx-translate/core';
import { MatTableExporterModule } from 'mat-table-exporter';


@NgModule({
    declarations: [
        MyPageComponent,
    ],
    exports: [],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        CoreModule,
        PartialsModule,
        MatTableModule,
        MatCheckboxModule,
        MatPaginatorModule,
        MatSortModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatSelectModule,
        MatTabsModule,
        MatDatepickerModule,
        MatTableExporterModule,
        NgbModule,
        TranslateModule.forChild(),
    ],
    providers: []
})
export class PagesModule {
}
